var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{attrs:{"id":"pages-core-footer","absolute":"","color":"transparent","padless":""}},[_c('v-container',{staticClass:"py-3"},[_c('div',{staticClass:"pages-footer-copy text-center text-md-right"},[_vm._v(" © "+_vm._s(_vm.year)+" WPX Hosting ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }